import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-69dfa25e")
const _hoisted_1 = { id: "mobile-helpers-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Tool Bar Unlocked", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Tool Bar Locked", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Center Viewport", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        style: _normalizeStyle({ display: _ctx.lockToolBar ? 'none' : 'flex' }),
        ref: "unlock",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleLock && _ctx.handleToggleLock(...args))),
        class: "tool-bar-lock"
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "lock-open",
          "aria-hidden": "true"
        }),
        _hoisted_2
      ], 4),
      _createElementVNode("button", {
        style: _normalizeStyle({ display: _ctx.lockToolBar ? 'flex' : 'none' }),
        ref: "lock",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleToggleLock && _ctx.handleToggleLock(...args))),
        class: "tool-bar-lock"
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "lock",
          "aria-hidden": "true"
        }),
        _hoisted_3
      ], 4)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCenterViewport && _ctx.handleCenterViewport(...args))),
        id: "center-viewport"
      }, [
        _hoisted_4,
        _createVNode(_component_font_awesome_icon, {
          icon: "mobile",
          "aria-hidden": "true"
        })
      ])
    ])
  ]))
}